<template>
    <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" v-model="visibilidadeDialogo">
        <az-call-to-action slot="activator" @click="mostrarCaixaDialogo" active class="text-uppercase botaoDesempatar">
            Declarar Vencedor
        </az-call-to-action>

        <v-card v-if="caixaVisivel" :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
            <v-card-title class="primary modal-title" primary-title>
                <span>Confirmar declação de vencedor</span>
                <v-btn flat depressed @click="fecharCaixaDialogo">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pb-0 az-form-content">
                <div class="mensagem-confirmacao__texto mb-3">
                    <p>
                        Deseja realmente declarar o fornecedor <strong>{{razaoSocial}}</strong> vencedor do <strong>{{itemOuLoteDescricao}}</strong>
                        <span v-if="mensagemValorAcimaMenorPreco">
                            , com <br> <strong style="color: #FF7070 !important;">valor acima do valor de referência</strong>
                        </span>
                        <span v-if="mensagemValorAbaixoMaiorDesconto">
                            , com <br> <strong style="color: #FF7070 !important;">percentual abaixo do percentual de referência</strong>
                        </span>
                        ?
                    </p>
                </div>
            </v-card-text>

            <v-card-actions class="px-3 py-2">
                <v-btn color="botao-cancelar-color" outline flat @click="fecharCaixaDialogo" id="btnCancelar">
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaoNegociar" color="primary" depressed @click="$emit('declararVencedor')">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'BotaoDeclararVencedor',
    props: ['itemOuLoteDescricao', 'razaoSocial', 'mensagemValorAcimaDaReferencia', 'criterioJulgamento'],
    data() {
        return {
            caixaVisivel: false,
            visibilidadeDialogo: false,
            Modal
        }
    },
    computed:{
        mensagemValorAcimaMenorPreco(){
            return this.mensagemValorAcimaDaReferencia && this.criterioJulgamento === 'MENOR_PRECO'
        },
        mensagemValorAbaixoMaiorDesconto(){
            return this.mensagemValorAcimaDaReferencia && this.criterioJulgamento === 'MAIOR_DESCONTO'
        }

    },
    methods: {
        mostrarCaixaDialogo() {
            this.caixaVisivel = true
        },
        fecharCaixaDialogo() {
            this.caixaVisivel = false
            this.visibilidadeDialogo = false
        }
    }
}
</script>

<style scoped lang="stylus">
    .mensagem-confirmacao
        &__texto
            text-align center
            color #777

    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>